<template>
  <el-card>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/' }">Admin</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/projects'}">Proyectos</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <br />
    <br />
    <app-table-paginate
      v-if="tableShow"
      :routeEdit="routeEdit"
      :tableQuery="getListProjects"
      :tableColumns="tableColumns"
      :limit="limit"
      :search="true"
    ></app-table-paginate>
    <br />
    <el-button type="primary" size="medium" @click="nuevoRegistro()">
      Añadir proyecto
      <i class="el-icon-circle-plus-outline el-icon-right"></i>
    </el-button>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";

export default {
  name: "Users",
  components: {
    "app-table-paginate": tablaConPaginador
  },
  created() {
    this.routeEdit = "/admin/projects/edit/";
    this.getProjects();

    setTimeout(() => {
      this.$root.$on("delete", id => {
        this.eliminarRegistro(id);
      });
    }, 200);
  },
  beforeDestroy() {
    this.$root.$off("delete", id => {
        this.eliminarRegistro(id);
      });
  },
  data() {
    return {
      usersAPI: false,
      loading: true,
      tableColumns: [
        {
          prop: "id",
          label: "#Id"
        },
        {
          prop: "project_name",
          label: "Nombre proyecto"
        },
        {
          prop: "dbhost",
          label: "Host"
        },
        {
          prop: "dbname",
          label: "Base de datos"
        },
        {
          prop: "dbuser",
          label: "Usuario"
        }
      ],
      searchQuery: "",
      routeEdit: null,
      deleterow: false,
      limit: 20,
      tableShow: false,
      projectsAPI: false
    };
  },
  methods: {
    async getProjects() {
      ApiService.post("admin/projects", {
        token: localStorage.getItem("token")
      }).then(response => {
        this.projectsAPI = response.data;
        this.tableShow = true;
      });
    },
    async eliminarRegistro(id) {
      this.tableShow = false;
      ApiService.post("admin/delete-project", {
        token: localStorage.getItem("token"),
        id: id
      }).then(response => {
        this.deleterow = response.data;
        setTimeout(() => {
          if (this.deleterow == 1) {
            this.$message({
              type: "success",
              message: "Se ha eliminado correctamente"
            });

            this.getUsers();
            setTimeout(() => {
              this.tableShow = true;
            }, 500);
          } else {
            this.$message({
              type: "warning",
              message: this.deleterow
            });
          }
        }, 200);
      });
    },
    nuevoRegistro() {
      this.$router.push("/admin/projects/new");
    }
  },
  computed: {
    getListProjects() {
      return this.projectsAPI;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/CloudAdmin/projects.vue